/**
 * Per-request opt-out key for `RequestInfo.options`. Set
 * `options: { [SkipErrorReporting]: true }` on a request to suppress
 * `TioResponseHandler`'s global session/toast behavior for that request — no
 * `unauthorized` (logout) and no `request-failed` (toast) events are emitted.
 * The error is still re-thrown so the caller's own `try/catch` runs unchanged.
 *
 * Lives in a neutral module (not the handler) so request builders can opt out
 * without importing handler internals, mirroring how the `SkipCache`
 * cache-option key is a neutral, shared constant.
 *
 * A plain string (not a `Symbol` like `SkipCache`): `RequestInfo.options` is
 * typed `Record<string, unknown>`, so a symbol key cannot index it without
 * casts. The key is namespaced and is currently the only key written to
 * `options` in this addon, so collision is a non-issue.
 *
 * Intended for non-critical, fire-and-forget calls whose failures must not
 * affect the session — e.g. the Wellness Train fetch/recalculation, where a
 * non-fatal 403 was surfacing an "Access denied" toast on login for users not
 * entitled to wellness (tuitionio/elevator-pitch#196).
 */
export const SkipErrorReporting = 'tioSkipErrorReporting';
